var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import BackToButton from "./BackToButton";
import { setFilters, getFilters } from "../../providers/FilterProvider";
import { createElement, useContext } from "react";
import { FilterRestrictionContext } from "../../providers/FilterRestrictionProvider";
import { restrictionKeyMap } from "../../hooks/restrictionSetup";
export var RestrictionClearingBackToButton = function (_a) {
    var backUrl = _a.backUrl, title = _a.title;
    var OnClickMisser = function (_a) {
        var onClick = _a.onClick;
        return createElement(BackToButton, { title: title, backUrl: backUrl, onClick: onClick });
    };
    return _jsx(OnClickable, { element: OnClickMisser });
};
export var OnClickable = function (_a) {
    var element = _a.element, onClick = _a.onClick, additional = _a.additional;
    var _b = useContext(FilterRestrictionContext), restrictions = _b.restrictions, setRestrictions = _b.setRestrictions;
    var clearableFilters = Object.keys(restrictions).map(function (key) { return restrictionKeyMap[key] || key; });
    var clearFilters = function () {
        return setFilters(__assign(__assign({}, getFilters()), clearableFilters.reduce(function (current, key) {
            var _a;
            return (__assign(__assign({}, current), (_a = {}, _a[key] = [], _a)));
        }, {})));
    };
    var onClear = function () {
        onClick && onClick({});
        clearFilters();
        setRestrictions({});
    };
    return createElement(element, __assign({ onClick: onClear }, (additional || {})));
};
